import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Input } from '../atom/Input';
import Icon from '../atom/Icon';
import ThemeStyle from '../../../lib/style/ThemeStyle';

const InputWithIcon = ({
  type = 'text',
  name,
  value,
  placeholder,
  mainIconName,
  subIconName,
  onChange,
  active,
  size = 2,
  ...props
}) => {
  const [finalType, setFinalType] = useState(type);
  const passwordToTextType = () => {
    if (type === 'password') {
      setFinalType(finalType === 'password' ? 'text' : 'password');
    }
  };

  return (
    <Container active={active} size={size}>
      <Icon iconName={mainIconName} />
      <Input
        type={finalType}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        {...props}
      />
      {subIconName && (
        <Icon
          iconName={subIconName}
          onClick={passwordToTextType}
          style={{
            color:
              finalType === 'text'
                ? ThemeStyle.color.darkest
                : ThemeStyle.color.pinkishGrey,
          }}
        />
      )}
    </Container>
  );
};

InputWithIcon.propTypes = {
  ...Input.propTypes,
  mainIconName: PropTypes.string,
  subIconName: PropTypes.string,
};

export default React.memo(InputWithIcon);

const Container = styled.div`
  display: flex;
  position: relative;
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.color.orangePink
        : props.theme.color.pinkishGrey};

  padding: ${(props) =>
    props.size === 3 ? '0.75rem 1.25rem' : '0.625rem 1rem'};

  i {
    color: ${({ theme }) => theme.color.pinkishGrey};
  }

  & + & {
    margin-top: 0.625rem;
  }
`;
